const successInsertData = 'Registro inserido com sucesso!';
const errorInsertData = 'Ocorreu uma falha ao inserir o registro. Tente novamente mais tarde.';
const successUpdateData = 'Registro alterado com sucesso!';
const errorUpdateData = 'Ocorreu uma falha ao alterar o registro. Tente novamente mais tarde.';
const successDeleteData = 'Registro excluído com sucesso!';
const errorDeleteData = 'Ocorreu uma falha ao excluir o registro. Tente novamente mais tarde.';
const errorGetData = 'Ocorreu uma falha ao buscar o registro. Tente novamente mais tarde.';
const errorListData = 'Ocorreu uma falha ao listar os registros. Tente novamente mais tarde.';
const questionCancelOperation = 'Deseja realmente cancelar a operação?';
const questionNewOperation = 'Deseja realmente iniciar um novo registro?';

export {
	successInsertData,
	successUpdateData,
	successDeleteData,
	errorGetData,
	errorInsertData,
	errorUpdateData,
    errorDeleteData,
	errorListData,
	questionNewOperation,
    questionCancelOperation
};
